const getColorClasses = (currentPath, validUrls = []) => {
  if (validUrls.some((url) => currentPath === url)) {
    return 'text-primary-400 fill-primary-400';
  }
  return 'text-secondary-400 fill-secondary-400';
};

export default getColorClasses;
